import { ButtonLink, ButtonModal } from "../../../../components";
import { TEMPLATE } from "../../../../constants";
import { handleBilling } from "./function";

import "./index.css";

const { MODAL_ACTION } = TEMPLATE.MODAL;

export const ActionItems = (
  record,
  setType,
  setIsOpenBill,
  setIsOpenRemark,
  setData,
  user,
  dispatch,
  messageApi
) => {
  const { status } = record;

  const isUserA = user?.uroleid === "A";

  const menuItems = [
    {
      key: 1,
      label:
        isUserA &&
        (status === 2 || status === 3 || status === 4 ? (
          <>Publish Billing</>
        ) : (
          <ButtonModal
            model={"link"}
            setmodal={MODAL_ACTION.confirmation_publish_billing_billing_list}
            type="primary"
            style={{ width: "100%", height: "100%" }}
            onClick={() => handleBilling(record, "unpaid", dispatch, messageApi, user)}
            extra={record}
          >
            Publish Billing
          </ButtonModal>
        )),
      disabled: isUserA && (status === 2 || status === 3 || status === 4),
    },
    {
      key: 2,
      label:
        isUserA &&
        (status === 1 || status === 4 ? (
          <>Verify Payment</>
        ) : (
          <ButtonModal
            model={"link"}
            setmodal={MODAL_ACTION.confirmation_verify_payment_billing_list}
            type="primary"
            style={{ width: "100%", height: "100%" }}
            onClick={() => handleBilling(record, "paid", dispatch, messageApi, user)}
            extra={record}
          >
            Verify Payment
          </ButtonModal>
        )),
      disabled: isUserA && (status === 1 || status === 4),
    },
    {
      key: 3,
      label:
        !isUserA &&
        (status === 1 || status === 3 || status === 4 ? (
          <>Pay bill</>
        ) : (
          <ButtonLink
            onClick={() => {
              setIsOpenBill(true);
              setData(record);
              setType("pay");
            }}
          >
            Pay Bill
          </ButtonLink>
        )),
      disabled: !isUserA && (status === 1 || status === 3 || status === 4),
    },
    {
      key: 4,
      label: <ButtonLink>Edit remarks</ButtonLink>,
      onClick: () => {
        setIsOpenRemark(true);
        setData(record);
      },
    },
  ];

  const filteredMenuItems = menuItems.filter((item) => item.label !== false);
  return filteredMenuItems;
};
